<template>
  <div name="overview" class=" mr-10">
    <div class="ml-6">
      <header class="flex justify-between mt-4 mb-6">
      
          
        <div class="pl-1">
          <h1 class="font-semibold text-base">Unit Overview</h1>
          <p class="text-xs ">{{description}}</p>
        </div>

        <img v-if="isConceptCurriculum"
          @click="openInNewTab('https://www.pescholar.com/insight/the-primary-physical-education-concept-curriculum/')"
          class="pl-2 w-2/12 object-scale-down"
            src="/static/images/pescholar-collab.png"
            alt=""
          />

      </header>

     

      <div class="w-full grid grid-cols-2 gap-4">
      <div
          v-for="lesson in orderedLessons"
          :key="lesson.id"
          @click="showLesson(lesson)"
          class="cursor-pointer hover:opacity-75 bg-list-grey mb-4 p-4 border border-gray-200 rounded overflow-hidden"
        >
        <div class="flex justify-between pb-1">
          <h4
            class="
              text-gray-800
              font-semibold
            "
          >
            {{ lesson.name }}
          </h4>
          <div class="text-xs font-semibold">
              <i
                class="fas fa-ellipsis-v ml-4 hover:opacity-75 text-sm bg-blue-100 p-2 px-3 hover:bg-blue-200 "
                v-on:click.stop.prevent="selectOptions(lesson)"
              >
            
            </i>
              <template >
              <transition
                enter-active-class="transition duration-300 ease-out transform"
                nter-class="-translate-y-3 scale-95 opacity-0"
                enter-to-class="translate-y-0 scale-100 opacity-100"
                leave-active-class="transition duration-150 ease-in transform"
                leave-class="translate-y-0 opacity-100"
                leave-to-class="-translate-y-3 opacity-0"
              >
                <div v-show="showingOptions(lesson)" class="absolute pt-2">
                  <div
                    class="
                      absolute
                      py-1
                      bg-white
                      border border-gray-200
                      rounded-md
                      shadow-xl
                    "
                  >
                    <div
                      class="
                        absolute
                        top-0
                        w-4
                        h-4
                        origin-center
                        transform
                        rotate-45
                        translate-x-5
                        -translate-y-2
                        bg-white
                        border-t border-l border-gray-200
                        rounded-sm
                        pointer-events-none
                      "
                    ></div>
                    <div class="relative">
                      <a
                        class="
                          block
                          w-full
                          px-4
                          py-2
                          font-medium
                          text-gray-700
                          whitespace-no-wrap
                          hover:bg-gray-100
                          focus:outline-none
                          hover:text-gray-900
                          focus:text-gray-900 focus:shadow-outline
                          transition
                          duration-300
                          ease-in-out
                        "
                        v-on:click.stop.prevent="showLesson(lesson)"
                        >View</a
                      >
                      <a
                        class="
                          block
                          w-full
                          px-4
                          py-2
                          font-medium
                          text-red-500
                          whitespace-no-wrap
                          hover:bg-gray-100
                          focus:outline-none
                          hover:text-gray-900
                          focus:text-gray-900 focus:shadow-outline
                          transition
                          duration-300
                          ease-in-out
                        "
                        v-on:click.stop.prevent="showEvidence(lesson)"
                        >Evidence</a
                      >
                      <a
                      v-on:click.stop.prevent="cancelSelect()"
                        class="
                          block
                          w-full
                          px-4
                          py-2
                          font-medium
                          text-blue-500
                          whitespace-no-wrap
                          hover:bg-gray-100
                          focus:outline-none
                          hover:text-gray-900
                          focus:text-gray-900 focus:shadow-outline
                          transition
                          duration-300
                          ease-in-out
                        "
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </transition>
            </template>
          </div>
        </div>
          <div class="flex justify-center items-center">
            <div class="flex-1">
              <p
                class="mt-1 text-gray-700 text-xs"
                v-html="lesson.outline"
              ></p>
            </div>
    
          </div>
      </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  
  name: "overview",
  props: {
    course: Object,
    lessons: Array,
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    orderedLessons() {
      return _.orderBy(this.lessons, ["order", "name"]);
    },
    description() {
      if (this.course.description != undefined && this.course.description.length > 0) {
        return this.course.description
      } else {
        return this.course.name + " lessons and plans."
      }
    },
    isConceptCurriculum() {
      return this.course.category.key_value === "concept"
    }
  },
  data() {
    return {
      lessonSelected: {},
      isMenuVisible: false,
    };
  },
  methods: {
    showLesson(lesson) {
      this.isMenuVisible = false;
      this.$emit("showLesson", lesson);
    },
    showEvidence() {
      this.isMenuVisible = false;
      this.$emit("showEvidence",  this.lessonSelected);
    },
    selectOptions(lesson) {
      this.lessonSelected = lesson;
      this.isMenuVisible = true;
    },
    showingOptions(lesson) {
      return (
        this.isMenuVisible === true &&
        this.lessonSelected.id === lesson.id
      );
    },
    cancelSelect() {
      this.lessonSelected = undefined
      this.isMenuVisible = false
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
